import type { PostMeta } from "../posts";

export const meta: PostMeta = {
  slug: "what-economics-honours-grads-do",
  title: "What Do Economics Honours Graduates Actually Do? Empirical Career Trajectories",
  description:
    "Empirical breakdown of career paths for DU Economics Honours graduates. Corporate consulting, investment banking, risk analytics, RBI DEPR Officers, Indian Economic Service (IES), and postgraduate research.",
  pubDate: "2026-06-28",
  updatedDate: "2026-07-28",
  authorSlug: "uday-kumar",
  category: "careers",
  tags: ["careers", "economics-honours", "consulting", "policy", "finance", "rbi-depr", "ies", "analytics"],
  readMinutes: 16,
  heroEyebrow: "Careers · Empirical Pathways Masterclass",
};

export function Body() {
  return (
    <>
      <p>
        BA (Hons) Economics from Delhi University is widely recognized as one of the most versatile undergraduate degrees in India. The quantitative rigour of the UGCF 2022 curriculum prepares graduates for diverse corporate and public-sector career paths.
      </p>

      <h2>1. Primary Career Verticals</h2>
      <div className="space-y-4 my-6">
        <div className="border border-rule bg-card p-5">
          <strong className="mono-label text-grade block text-base mb-1">Vertical 1: Management Consulting &amp; Strategy</strong>
          <p className="text-sm">
            Recruitment into top strategy consultancies (McKinsey, BCG, Bain, LEK) and Big 4 advisory firms (Deloitte, PwC, EY, KPMG) for business analyst and associate roles.
          </p>
        </div>
        <div className="border border-rule bg-card p-5">
          <strong className="mono-label text-grade block text-base mb-1">Vertical 2: Central Banking &amp; Indian Economic Service (IES)</strong>
          <p className="text-sm">
            Entry into public economic policymaking via the Indian Economic Service exam conducted by{" "}
            <a href="https://upsc.gov.in/" target="_blank" rel="noopener noreferrer">
              UPSC
            </a>{" "}
            and Grade B Officers (DEPR) at the{" "}
            <a href="https://www.rbi.org.in/" target="_blank" rel="noopener noreferrer">
              Reserve Bank of India
            </a>
            .
          </p>
        </div>
        <div className="border border-rule bg-card p-5">
          <strong className="mono-label text-grade block text-base mb-1">Vertical 3: Data Science &amp; Statistical Survey Research</strong>
          <p className="text-sm">
            Roles utilizing econometrics and statistical tools on national datasets compiled by{" "}
            <a href="https://mospi.gov.in/" target="_blank" rel="noopener noreferrer">
              MoSPI
            </a>{" "}
            and NITI Aayog.
          </p>
        </div>
      </div>

      <h2>2. Related Postgraduate Guides</h2>
      <p>
        Plan your next steps after graduation with our guides on{" "}
        <a href="/blog/is-ma-economics-worth-it" className="font-semibold underline text-grade">
          Is an MA in Economics Worth It?
        </a>{" "}
        and{" "}
        <a href="/blog/cat-vs-civil-services-vs-masters" className="font-semibold underline text-grade">
          CAT vs Civil Services vs Master's
        </a>
        .
      </p>
    </>
  );
}


